import { styled } from '@mui/system';
import { Box, Chip } from '@mui/material';
import { SectionHeading, SectionSubtext } from '../../../Splash/styles';

export const HeroContentBox = styled(Box)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.down('md')]: {
    padding: '0 20px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 16px',
  },
}));

export const HeroTitle = styled(SectionHeading)(({ theme }) => ({
  ...theme.typography.heading,
  letterSpacing: '-1.5px',
  fontFamily: 'Gotham',
  fontWeight: 400,
  fontSize: '60px',
  lineHeight: '77px',
  textAlign: 'center',
  textTransform: 'capitalize',
  [theme.breakpoints.down('lg')]: {
    fontSize: '50px',
    lineHeight: '64px',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '36px',
    lineHeight: '46px',
    letterSpacing: '-1px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '28px',
    lineHeight: '36px',
  },
}));

export const HeroSubtext = styled(SectionSubtext)(({ theme }) => ({
  ...theme.typography.subtext,
  whiteSpace: 'pre-line',
  fontFamily: 'Quicksand',
  fontWeight: 400,
  fontSize: '28px !important',
  lineHeight: '33px',
  letterSpacing: '.4px',
  textAlign: 'center !important',
  margin: '18px auto auto',
  [theme.breakpoints.down('md')]: {
    fontSize: '22px !important',
    lineHeight: '28px',
    margin: '14px auto auto',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '18px !important',
    lineHeight: '24px',
    margin: '12px auto auto',
  },
}));

export const HeroSecondarySubtext = styled(SectionSubtext)(({ theme }) => ({
  ...theme.typography.subtext,
  whiteSpace: 'pre-line',
  fontFamily: 'Gotham',
  fontSize: '23px !important',
  lineHeight: '33px',
  letterSpacing: '-.4px',
  textAlign: 'center',
  margin: '46px auto auto',
  fontWeight: 400,
  textTransform: 'capitalize',
  [theme.breakpoints.down('md')]: {
    fontSize: '20px !important',
    lineHeight: '28px',
    margin: '32px auto auto',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '18px !important',
    lineHeight: '24px',
    margin: '24px auto auto',
  },
}));

export const TagsContainer = styled(Box)(({ theme }) => ({
  marginTop: '20px',
  [theme.breakpoints.down('md')]: {
    marginTop: '16px',
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '14px',
  },
}));

export const TagRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '14px',
  marginBottom: '14px',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

export const ServiceChip = styled(Chip)(({ theme }) => ({
  backgroundColor: 'white',
  borderRadius: '23px',
  fontFamily: 'Quicksand',
  fontWeight: 500,
  fontSize: '20px',
  lineHeight: '20px',
  letterSpacing: '.4px',
  textTransform: 'capitalize',
  padding: '20px 33px',
  gap: '14px',
  minHeight: '60px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',

  [theme.breakpoints.up('md')]: {
    fontSize: '22px',
    minHeight: '74px',
    lineHeight: '24px',
  },

  '& .MuiChip-label': {
    fontWeight: 500,
    fontFamily: 'Quicksand, "Trebuchet MS", Arial, sans-serif',
    fontSize: '20px',
    textAlign: 'center',
    padding: '0',
    [theme.breakpoints.down('md')]: { fontSize: '18px', lineHeight: '24px' },
    [theme.breakpoints.down('sm')]: { fontSize: '16px', lineHeight: '24px' },
  },
  '& .MuiChip-icon': {
    margin: '0',
    width: '23px',
    height: '23px',
  },
}));

export const HeroImage = styled(Box)(({ theme }) => ({
  height: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  display: 'block',
  aspectRatio: '16/9',
  objectFit: 'cover',
  borderRadius: theme.spacing(6),
  border: '10px solid white',
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  [theme.breakpoints.up('md')]: {
    width: '1080px',
    height: '720px',
    marginTop: '50px',
  },
}));

export const checkIconStyles = {
  color: 'black !important',
  margin: '0',
};
